import { useState } from 'react';
import { useMedia, useLocalStorage } from 'react-use';
import useDeferredPrompt from './useDeferredPrompt';

const EXPIRED = 1000 * 60 * 60 * 24 * 14;

export default function useInstall() {
    const deferredPrompt = useDeferredPrompt();
    const isStandalone = useMedia('(display-mode: standalone)');
    const [dismissAt, setDismissAt] = useLocalStorage('install_dismiss_at', 0);
    const [isOpen, setOpen] = useState(dismissAt + EXPIRED < Date.now());

    function dismiss() {
        setOpen(false);
        setDismissAt(Date.now());
    }

    function accept() {
        setOpen(false);
    }

    async function install(e) {
        e.preventDefault();
        deferredPrompt.prompt();

        const choiceResult = await deferredPrompt.userChoice;
        if (choiceResult.outcome === 'accepted') {
            accept();
        } else {
            dismiss();
        }
    }

    return {
        isOpen: !isStandalone && deferredPrompt && isOpen,
        dismiss,
        install,
    };
}
